import React, { Component, createRef } from "react";
// // Editable
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import validate from "../../common/validation";

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Table,
} from "reactstrap";

import { withTranslation } from "react-i18next";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";

class PartyWiseStockReport extends Component {
  constructor(props) {
    console.log(props);
    super(props);
    this.state = {
      props: props?.location?.query,
      validation: "",
      editRowIndex: -1,
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
    this.categoriTypes = [
      { value: "HPHT", label: "HPHT" },
      { value: "LPHT", label: "LPHT" },
      { value: "REAL", label: "REAL" },
      { value: "JIRAM", label: "JIRAM" },
    ];

    this.products1 = [
      {
        id: "01",
        categories: "HPHT",
        weight: 1.5,
        pieces: 1,
        remarks: "",
      },
      {
        id: "02",
        categories: "LPHT",
        weight: 1.5,
        pieces: 1,
        remarks: "",
      },
      {
        id: "03",
        categories: "REAL",
        weight: 1.5,
        pieces: 1,
        remarks: "",
      },
      {
        id: "04",
        categories: "JIRAM",
        weight: 1.5,
        pieces: 1,
        remarks: "",
      },
    ];
  }

  handleSubmit(e) {
    e.preventDefault();

    const modifiedV = { ...this.state.validation };

    this.setState({ validation: modifiedV });
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    //meta title
    this.columns1 = [
      {
        dataField: "id",
        text: `${this.props.t("Sr.No.")}`,
        footer: `${this.props.t("Total")}`,
      },
      {
        dataField: "mainJangad",
        text: "Categories",
        formatter: (cell, row) => {
          return this.state?.props?.data?.mainJangad?.category?.name;
        },
        footer:"" 
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight / Carat")}`,
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2) + " CT",
        formatter: (cell, row, rowIndex) => {
          return cell + " CT";
        },
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
        formatter: (cell, row, rowIndex) => {
          return cell;
        },
      },
      {
        dataField: "remarks",
        text: "Party Remarks",
        footer:""
      },
    ];

    document.title = "admin-report";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem="Party Wise Stock Report" />
            <Card>
              <Formik
                enableReinitialize={true}
                initialValues={{
                  partyName: (this.state && this.state.partyName) || "",
                  unitName: (this.state && this.state.unitName) || "",
                }}
                validationSchema={Yup.object().shape({})}
                onSubmit={values => {
                  console.log(values);
                }}
              >
                {({ errors, status, touched, values }) => (
                  <Form className="needs-validation">
                    <div className="pt-3">
                      <div className="row">
                        <div className="d-xxl-flex d-block justify-content-between px-4">
                          <div>
                            <h4 className="text-black fw-bold mb-4">
                              Party Wise Stock Report
                            </h4>
                          </div>
                          <div className="pt-3 pt-xxl-0">
                            <label htmlFor="date">
                              <h4 className="text-black fw-bold pe-3">
                                {" "}
                                {this.props.t("From Date")}:
                              </h4>
                            </label>
                            <input
                              type="date"
                              className="fs-4 text-black border-0"
                              name="date"
                            />
                            <label htmlFor="date" className="px-0 px-md-3">
                              <h4 className="text-black fw-bold pe-3">
                                {this.props.t("To Date")}:
                              </h4>
                            </label>
                            <input
                              type="date"
                              className="fs-4 text-black border-0"
                              name="date"
                            />
                          </div>

                          {/* <div>
                            <label
                              htmlFor="date"
                              className="fs-4 pe-2 text-black fw-bold"
                            >
                              Date:
                            </label>
                            <input type="date" className="fs-4 border-0" />
                          </div> */}
                        </div>
                        <div className="col-xl-8 col-12">
                          <CardBody>
                            <Row>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="partyName"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Party Name")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.partyName && touched.partyName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    value={
                                      this.state.props.data.mainJangad.party
                                        .name
                                    }
                                    readOnly={true}
                                    type="text"
                                    name="partyName"
                                    placeholder="XYZ Diamond"
                                  />
                                  <ErrorMessage
                                    name="partyName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="unitName"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Unit Name")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.unitName && touched.unitName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    readOnly={true}
                                    value={this.state.props.data.factory.name}
                                    type="text"
                                    name="unitName"
                                    placeholder="ABC Diamond Unit"
                                  />
                                  <ErrorMessage
                                    name="unitName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                            </Row>
                          </CardBody>
                        </div>
                        <div className="col-xl-4 col-12 pt-3">
                          <div className="px-4">
                            <div className="row border-gray py-3">
                              <div className="col-md-5 col-12 pt-2">
                                <h5>{this.props.t("Contact Person")} :</h5>
                              </div>
                              <div className="col-md-7 col-12 pt-2">
                                <h5>
                                  {
                                    this.state.props.data.mainJangad.party
                                      .contactPersonName
                                  }
                                </h5>
                              </div>
                              <div className="col-md-5 col-12 pt-2">
                                <h5>{this.props.t("Mobile no.1")} : </h5>
                              </div>
                              <div className="col-md-7 col-12 pt-2">
                                <h5>
                                  {
                                    this.state.props.data.mainJangad.party
                                      .mobileNo1
                                  }
                                </h5>
                              </div>
                              <div className="col-md-5 col-12 pt-2">
                                <h5>{this.props.t("Mobile no.2")} : </h5>
                              </div>
                              <div className="col-md-7 col-12 pt-2">
                                <h5>
                                  {
                                    this.state.props.data.mainJangad.party
                                      .mobileNo2
                                  }
                                </h5>
                              </div>
                              <div className="col-md-5 col-12 pt-2">
                                <h5>{this.props.t("Email Address")} : </h5>
                              </div>
                              <div className="col-md-7 col-12 pt-2">
                                <h5>
                                  {this.state.props.data.mainJangad.party.email}
                                </h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {this.state.props.data.dataEntryStock != null ? (
                        <>
                          {
                            <div className="table-responsive">
                              <BootstrapTable
                                keyField="id"
                                classes="foo"
                                headerClasses="background-light fs-5"
                                footerClasses="background-light fs-5"
                                bootstrap4={true}
                                data={this.state.props.data?.dataEntryStock?.stockDataEntryInWards}
                                columns={this.columns1}
                              />
                            </div>
                          }
                        </>
                      ) : (
                        <></>
                      )}

                      <div className="col-md-12 text-center text-md-end pe-3 py-5">
                        <Button
                          color="primary"
                          className="fs-4 px-5"
                          type="submit"
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(PartyWiseStockReport);
